import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconSlice: React.NamedExoticComponent<CentralIconBaseProps> = React.memo(React.forwardRef<SVGSVGElement, CentralIconBaseProps>((props, ref) => {
  return <CentralIconBase {...props} ref={ref} ariaLabel={"slice, knife"} maskId="square-filled-radius-0-stroke-1-IconSlice"><path d="M5.49965 2.79321L1.79297 6.4999L7.29297 11.9999L4.29371 14.9992L4.64578 15.3527C7.84305 18.5634 10.4262 20.1898 13.0833 20.7566C15.731 21.3214 18.3754 20.8148 21.6293 19.9446L22.4675 19.7205L5.49965 2.79321Z" fill="currentColor"/></CentralIconBase>;
}));

export default IconSlice;
